const emptyRound = Array(18).fill(null);

class GolferObject {
    constructor(id, name) {
        this.Name = name;
        this.Id = id;
        this.Scores = [[...emptyRound], [...emptyRound], [...emptyRound], [...emptyRound]];
        this.RoundScores = [0, 0, 0, 0];
        this.course_ids = ["0", "0", "0", "0"];
        this.TotalScore = 0;
        this.Points = 0;
        this.Num_Picked = 1;
        this.Picked = false;
        this.eagles = 0;
        this.birdies = 0;
        this.bogies = 0;
        this.Cut = 0;
        this.holes_remaining = 0;
        this.Group_Num = 0;
        this.Shot_Details = [null,null,null,null];
        this.Show_Hole = 0; // zero based, tab control hole number, course hole number.  Not players nth hole played (if they started on 10)
        this.Show_PBP = false;
    }
}

export default GolferObject;